import { parse } from 'query-string';
import { createSelector } from 'reselect';

export const getPathname = (props) => props.location.pathname;
const getSearch = (props) => props.location.search;

export const getQuerySearch = createSelector(getSearch, (search) => parse(search));
